import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import Global from '../../store/global-selectors';
import { cancelShipmentRefundsAsync } from '../../pages/settings/refund-assist/api';
import { REFUND_STATUS_TYPES } from '../refund-status/refund-status-mappings';

import style from './shared-classes.module.less';
import messages from './messages';
import { Segment } from '../../services/analytics-services/segment';
import { REFUND_ASSIST_EXCLUDE_BUTTON_CLICK } from '../../constants/analytics-events';

export const ExcludeFromRefundButton = () => {
  const selectedFulfillmentIds = useSelector(Global.selectSelectedShipmentsSelectedShipmentIds);
  const oneOrMoreShipmentSelected = selectedFulfillmentIds.length > 0;
  const fulfillments = useSelector((state) =>
    Global.selectEntitiesFulfillmentsByIds(state, {
      fulfillmentIds: selectedFulfillmentIds,
    }),
  );

  const hasRefundRequested = fulfillments.some((f) => f.shipmentRefundStatusTypeId === REFUND_STATUS_TYPES.REQUEST_SCHEDULED);
  const shouldEnableButton = oneOrMoreShipmentSelected && hasRefundRequested;
  const disabled = !shouldEnableButton;

  const cancelRefunds = useCallback(() => {
    cancelShipmentRefundsAsync(selectedFulfillmentIds);
    Segment.trackEvent(REFUND_ASSIST_EXCLUDE_BUTTON_CLICK, {
      selectedFulfillmentIds,
    });
  }, [selectedFulfillmentIds]);

  return (
    <Button className={style['action-button']} disabled={disabled} onClick={cancelRefunds} theme='tertiary'>
      <FormattedMessage {...messages.excludeFromRefundButtonLabel} />
    </Button>
  );
};
